import React from 'react';
import VariantSheetMobile from '../VariantSheetDesktop/VariantSheetMobile';

interface VariantOptionModalMobileProps {
  isOpen: boolean;
  onClose: () => void;
  product: any;
  variants: any[];
  hierarchicalVariants?: any[];
  variantHierarchy?: string[];
}

const VariantOptionModalMobile: React.FC<VariantOptionModalMobileProps> = ({
  isOpen,
  onClose,
  product,
  variants,
  hierarchicalVariants,
  variantHierarchy,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    onClose();
  };
  return (
    <>
      <div className="bottom-sheet-overlay" onClick={handleOverlayClick} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1000, background: 'rgba(0,0,0,0.5)' }} />
      <div className="variant-modal-mobile bottom-sheet-modal" style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1100 }}>
        <VariantSheetMobile
          product={product}
          variants={variants}
          hierarchicalVariants={hierarchicalVariants}
          variantHierarchy={variantHierarchy}
        />
      </div>
    </>
  );
};

export default VariantOptionModalMobile;
